export default __webpack_public_path__ + "static/media/seity-health.png";